var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-treeview", {
        attrs: {
          items: _vm.items,
          checkbox: "",
          root: "",
          "expand-all": "",
          "icon-field": "icon"
        },
        model: {
          value: _vm.selectedItems,
          callback: function($$v) {
            _vm.selectedItems = $$v
          },
          expression: "selectedItems"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0de3d508", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de3d508","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Gallery.vue
// module id = null
// module chunks = 